import { render } from "./permissionSet.vue?vue&type=template&id=61144eaa&scoped=true&ts=true"
import script from "./permissionSet.vue?vue&type=script&lang=ts"
export * from "./permissionSet.vue?vue&type=script&lang=ts"

import "./permissionSet.vue?vue&type=style&index=0&id=61144eaa&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61144eaa"]])

export default __exports__